var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-form-item",
        { attrs: { label: "分割文案" } },
        [
          _c("el-input", {
            attrs: { placeholder: "请输入分割线内文案" },
            model: {
              value: _vm.activeData.content,
              callback: function ($$v) {
                _vm.$set(_vm.activeData, "content", $$v)
              },
              expression: "activeData.content",
            },
          }),
        ],
        1
      ),
      _c(
        "el-form-item",
        { attrs: { label: "分割样式" } },
        [
          _c(
            "el-select",
            {
              attrs: { placeholder: "请选择" },
              model: {
                value: _vm.activeData.borderStyle,
                callback: function ($$v) {
                  _vm.$set(_vm.activeData, "borderStyle", $$v)
                },
                expression: "activeData.borderStyle",
              },
            },
            _vm._l(_vm.borderStyleOptions, function (item) {
              return _c(
                "el-option",
                {
                  key: item.value,
                  attrs: { label: item.label, value: item.value },
                },
                [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        width: "100%",
                        display: "flex",
                        "justify-content": "space-around",
                        "align-items": "center",
                      },
                    },
                    [
                      _c("span", [_vm._v(_vm._s(item.label))]),
                      _c("div", {
                        style: {
                          flex: "1",
                          marginLeft: "6px",
                          borderTop: "1px " + item.value + " #999999",
                        },
                      }),
                    ]
                  ),
                ]
              )
            }),
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }